import React, { useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaBook,
  FaUserCog,
  FaSignOutAlt,
  FaFileInvoiceDollar,
  FaExchangeAlt,
} from "react-icons/fa";
import SettingsIcon from "@mui/icons-material/Settings";
import ClassIcon from "@mui/icons-material/Class";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MopedIcon from "@mui/icons-material/Moped";
import PublicIcon from "@mui/icons-material/Public";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import HailIcon from "@mui/icons-material/Hail";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import CarRentalIcon from "@mui/icons-material/CarRental";
import AddReactionIcon from "@mui/icons-material/AddReaction";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ElevatorIcon from "@mui/icons-material/Elevator";
import InventoryIcon from "@mui/icons-material/Inventory";
import EngineeringIcon from "@mui/icons-material/Engineering";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import SellIcon from "@mui/icons-material/Sell";
import SensorOccupiedIcon from "@mui/icons-material/SensorOccupied";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import PaymentIcon from "@mui/icons-material/Payment";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ConstructionIcon from "@mui/icons-material/Construction";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddCardIcon from "@mui/icons-material/AddCard";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import PaymentsIcon from "@mui/icons-material/Payments";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PostAddIcon from "@mui/icons-material/PostAdd";
import ApprovalIcon from "@mui/icons-material/Approval";
import RateReviewIcon from "@mui/icons-material/RateReview";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import BalanceIcon from "@mui/icons-material/Balance";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import AddchartIcon from "@mui/icons-material/Addchart";
import SoapIcon from "@mui/icons-material/Soap";
import DoorSlidingIcon from "@mui/icons-material/DoorSliding";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import TodayIcon from "@mui/icons-material/Today";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";

const Sidebar = ({
  image,
  collapsed,
  toggled,
  handleToggleSidebar,
  handleCollapsedChange,
}) => {
  const { user, dispatch, setting } = useContext(AuthContext);
  const navigate = useNavigate();

  const logoutButtonHandler = async (e) => {
    e.preventDefault();
    dispatch({ type: "LOGOUT" });
    navigate("/");
  };

  return (
    <ProSidebar
      // image={image ? sidebarBg : false}
      collapsed={collapsed}
      toggled={toggled}
      onToggle={handleToggleSidebar}
      breakPoint="md"
    >
      {/* HEADER */}
      <SidebarHeader>
        <Menu iconShape="circle">
          {collapsed ? (
            <MenuItem
              icon={<FaAngleDoubleRight />}
              onClick={handleCollapsedChange}
            ></MenuItem>
          ) : (
            <MenuItem
              suffix={<FaAngleDoubleLeft />}
              onClick={handleCollapsedChange}
            >
              <div
                style={{
                  padding: "9px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  fontSize: 15,
                  letterSpacing: "1px",
                }}
              >
                {setting.namaProgram} {setting.namaSoftware}
              </div>
            </MenuItem>
          )}
        </Menu>
      </SidebarHeader>
      {/* CONTENT */}
      <SidebarContent>
        <Menu>
          <SubMenu
            title={"Dashboard"}
            icon={<QueryStatsIcon name="dashboard-icon" />}
          >
            {user.tipeUser === "OWN/DIREKSI" && (
              <MenuItem icon={<AutoGraphIcon name="dashboard-owner-icon" />}>
                Dashboard Owner <NavLink to="/dashboardOwner" />
              </MenuItem>
            )}
            {user.tipeUser === "MGR" && (
              <MenuItem icon={<LeaderboardIcon name="dashboard-owner-icon" />}>
                Dashboard Manager <NavLink to="/dashboardCabang" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu title={"Master"} icon={<ClassIcon name="master-icon" />}>
            {user.akses.motor === true && (
              <SubMenu title={"Motor"} icon={<MopedIcon name="motor-icon" />}>
                <MenuItem>
                  Tipe/Merk <NavLink to="/tipe" />
                </MenuItem>
                <MenuItem>
                  Warna <NavLink to="/warna" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.area === true && (
              <SubMenu title={"Area"} icon={<PublicIcon name="area-icon" />}>
                <MenuItem>
                  Wilayah <NavLink to="/wilayah" />
                </MenuItem>
                <MenuItem>
                  Kecamatan <NavLink to="/kecamatan" />
                </MenuItem>
                <MenuItem>
                  Kelurahan <NavLink to="/kelurahan" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.bukuBesar === true && (
              <SubMenu
                title={"Buku Besar"}
                icon={<MenuBookIcon name="buku-besar-icon" />}
              >
                <MenuItem>
                  Jenis COA <NavLink to="/jenisCOA" />
                </MenuItem>
                <MenuItem>
                  Group COA <NavLink to="/groupCOA" />
                </MenuItem>
                <MenuItem>
                  Sub Group COA <NavLink to="/subGroupCOA" />
                </MenuItem>
                <MenuItem>
                  COA <NavLink to="/coa" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.dealer === true && (
              <MenuItem icon={<PersonPinIcon name="dealer-icon" />}>
                Dealer <NavLink to="/dealer" />
              </MenuItem>
            )}
            {user.akses.kolektor === true && (
              <MenuItem icon={<SensorOccupiedIcon name="dealer-icon" />}>
                Eksekutor <NavLink to="/kolektor" />
              </MenuItem>
            )}
            {user.akses.marketing === true && (
              <MenuItem icon={<AddBusinessIcon name="marketing-icon" />}>
                Marketing <NavLink to="/marketing" />
              </MenuItem>
            )}
            {user.akses.pekerjaan === true && (
              <MenuItem icon={<EngineeringIcon name="pekerjaan-icon" />}>
                Pekerjaan <NavLink to="/pekerjaan" />
              </MenuItem>
            )}
            {user.akses.headSurveyor === true && (
              <MenuItem icon={<HailIcon name="headSurveyor-icon" />}>
                Head Surveyor <NavLink to="/headSurveyor" />
              </MenuItem>
            )}
            {user.akses.surveyor === true && (
              <MenuItem icon={<HailIcon name="surveyor-icon" />}>
                Surveyor <NavLink to="/surveyor" />
              </MenuItem>
            )}
            {user.akses.leasing === true && (
              <MenuItem icon={<CarRentalIcon name="leasing-icon" />}>
                Leasing <NavLink to="/leasing" />
              </MenuItem>
            )}
            {user.akses.supplier === true && (
              <MenuItem icon={<AddReactionIcon name="supplier-icon" />}>
                Supplier <NavLink to="/supplier" />
              </MenuItem>
            )}
            {user.akses.agama === true && (
              <MenuItem icon={<AddReactionIcon name="agama-icon" />}>
                Agama <NavLink to="/agama" />
              </MenuItem>
            )}
            {user.akses.agen === true && (
              <MenuItem icon={<AddBusinessIcon name="agen-icon" />}>
                Agen <NavLink to="/agen" />
              </MenuItem>
            )}
            {user.akses.statusRumah === true && (
              <MenuItem icon={<PersonPinIcon name="status-rumah-icon" />}>
                Status Rumah <NavLink to="/statusRumah" />
              </MenuItem>
            )}
            {user.akses.team === true && (
              <MenuItem icon={<HailIcon name="team-icon" />}>
                Team <NavLink to="/team" />
              </MenuItem>
            )}
            {user.akses.masterCustomer === true && (
              <MenuItem icon={<AddReactionIcon name="masterCustomer-icon" />}>
                Master Customer <NavLink to="/masterCustomer" />
              </MenuItem>
            )}
            {(user.tipeUser === "OWN/DIREKSI" ||
              user.tipeUser === "HEADSURVEYOR" ||
              user.tipeUser === "HEADKOLEKTOR") &&
              user.akses.customerPerSurveyor === true && (
                <MenuItem
                  icon={<AddReactionIcon name="customerPerSurveyor-icon" />}
                >
                  Customer Per Surveyor <NavLink to="/customerPerSurveyor" />
                </MenuItem>
              )}
            {/* {user.akses.cabang === true && (
              <MenuItem icon={<AddHomeWorkIcon name="cabang-icon" />}>
                Cabang <NavLink to="/cabang" />
              </MenuItem>
            )} */}
          </SubMenu>
          <SubMenu
            title={"Pembelian"}
            icon={<AddShoppingCartIcon name="pembelian-icon" />}
          >
            {user.akses.beli === true && (
              <MenuItem icon={<ShoppingBagIcon name="beli-icon" />}>
                Beli <NavLink to="/daftarBeli" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Penjualan"}
            icon={<CurrencyExchangeIcon name="penjualan-icon" />}
          >
            {user.akses.register === true && (
              <MenuItem icon={<CurrencyExchangeIcon name="penjualan-icon" />}>
                Register <NavLink to="/register" />
              </MenuItem>
            )}
            {user.akses.reject === true && (
              <MenuItem icon={<CancelPresentationIcon name="reject-icon" />}>
                Reject <NavLink to="/daftarReject" />
              </MenuItem>
            )}
            {user.akses.customer === true && (
              <MenuItem icon={<CancelPresentationIcon name="customer-icon" />}>
                Customer <NavLink to="/customer" />
              </MenuItem>
            )}
            {user.akses.jual === true && (
              <MenuItem icon={<SellIcon name="register-icon" />}>
                Jual <NavLink to="/jual" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Survey"}
            icon={<ManageSearchIcon name="Survey-icon" />}
          >
            {user.akses.registerSurvey === true && (
              <MenuItem icon={<RequestQuoteIcon name="register-survey-icon" />}>
                Register Survey <NavLink to="/registerSurvey" />
              </MenuItem>
            )}
            {user.akses.plafon === true && (
              <MenuItem icon={<RequestQuoteIcon name="plafon-icon" />}>
                Plafon <NavLink to="/plafon" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Perawatan"}
            icon={<ConstructionIcon name="Perawatan-icon" />}
          >
            {user.akses.biayaPerawatan === true && (
              <MenuItem icon={<RequestQuoteIcon name="biaya-perawatan-icon" />}>
                Biaya Perawatan <NavLink to="/biayaPerawatan" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Finance"}
            icon={<MonetizationOnIcon name="Finance-icon" />}
          >
            {user.akses.kasMasuk === true && (
              <MenuItem icon={<AddCardIcon name="kas-masuk-icon" />}>
                Kas Masuk <NavLink to="/daftarKasMasuk" />
              </MenuItem>
            )}
            {user.akses.kasKeluar === true && (
              <MenuItem icon={<CardMembershipIcon name="kas-keluar-icon" />}>
                Kas Keluar <NavLink to="/daftarKasKeluar" />
              </MenuItem>
            )}
            {user.akses.bankMasuk === true && (
              <MenuItem icon={<FileOpenIcon name="bank-masuk-icon" />}>
                Bank Masuk <NavLink to="/daftarBankMasuk" />
              </MenuItem>
            )}
            {user.akses.bankKeluar === true && (
              <MenuItem
                icon={<IndeterminateCheckBoxIcon name="bank-keluar-icon" />}
              >
                Bank Keluar <NavLink to="/daftarBankKeluar" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Piutang"}
            icon={<PriceChangeIcon name="utility-icon" />}
          >
            <SubMenu
              title={"Angsuran"}
              icon={<PublicIcon name="angsuran-icon" />}
            >
              {user.akses.angsuran === true && (
                <MenuItem icon={<PaymentIcon name="profil-icon" />}>
                  Angsuran <NavLink to="/daftarAngsuran" />
                </MenuItem>
              )}
              {user.akses.percepatan === true && (
                <MenuItem icon={<PaymentIcon name="profil-icon" />}>
                  Entry Percepatan <NavLink to="/tambahPercepatan" />
                </MenuItem>
              )}
            </SubMenu>
            <SubMenu
              title={"Angsuran Beda Cabang"}
              icon={<PublicIcon name="angsuran-icon" />}
            >
              {user.akses.angsuranBedaCabang === true && (
                <MenuItem icon={<PaymentIcon name="profil-icon" />}>
                  Angsuran <NavLink to="/daftarAngsuranBedaCabang" />
                </MenuItem>
              )}
              {user.akses.percepatanBedaCabang === true && (
                <MenuItem icon={<PaymentIcon name="profil-icon" />}>
                  Entry Percepatan <NavLink to="/tambahPercepatanBedaCabang" />
                </MenuItem>
              )}
            </SubMenu>
            <SubMenu title={"RST"} icon={<ManageHistoryIcon name="rst-icon" />}>
              {user.akses.rst1 === true && (
                <MenuItem icon={<PaymentIcon name="rst-1-icon" />}>
                  RST 1 <NavLink to="/rst1" />
                </MenuItem>
              )}
              {user.akses.rst2 === true && (
                <MenuItem icon={<PaymentIcon name="rst-2-icon" />}>
                  RST 2 <NavLink to="/rst2" />
                </MenuItem>
              )}
            </SubMenu>
            {user.akses.cekAngsuran === true && (
              <MenuItem icon={<HistoryEduIcon name="cek-angsuran-icon" />}>
                Cek Angsuran <NavLink to="/cekAngsuran" />
              </MenuItem>
            )}
            {user.akses.sp === true && (
              <MenuItem icon={<HistoryEduIcon name="sp-icon" />}>
                SP <NavLink to="/suratPemberitahuan" />
              </MenuItem>
            )}
            {user.akses.st === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                ST <NavLink to="/suratPenarikan" />
              </MenuItem>
            )}
            {user.akses.suratSomasi === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Surat Somasi <NavLink to="/suratSomasi" />
              </MenuItem>
            )}
            {user.akses.suratSomasiTahap2 === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Surat Somasi Tahap 2 <NavLink to="/suratSomasiTahap2" />
              </MenuItem>
            )}
            {user.akses.laporanPolisi === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Laporan Polisi <NavLink to="/laporanPolisi" />
              </MenuItem>
            )}
            {user.akses.penarikan === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Pelunasan Program <NavLink to="/penarikan" />
              </MenuItem>
            )}
            {user.akses.titip === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Tarik/Titip <NavLink to="/titip" />
              </MenuItem>
            )}
            {user.akses.sweeping === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Sweeping <NavLink to="/sweeping" />
              </MenuItem>
            )}
            {user.akses.motorHilang === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Motor Hilang <NavLink to="/motorHilang" />
              </MenuItem>
            )}
            {user.akses.konsumenJatuhTempo === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Konsumen Jatuh Tempo <NavLink to="/konsumenJatuhTempo" />
              </MenuItem>
            )}
            {user.akses.pointKembali === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Point Kembali <NavLink to="/pointKembali" />
              </MenuItem>
            )}
            {user.akses.hapusBuku === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Hapus Buku <NavLink to="/hapusBuku" />
              </MenuItem>
            )}
            {user.akses.bukaHapusBuku === true && (
              <MenuItem icon={<CompareArrowsIcon name="sp-icon" />}>
                Buka Hapus Buku <NavLink to="/bukaHapusBuku" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Laporan"}
            icon={<InventoryIcon name="utility-icon" />}
          >
            {user.akses.daftarStok === true && (
              <MenuItem icon={<FormatListNumberedIcon name="profil-icon" />}>
                Daftar Stok <NavLink to="/daftarStok" />
              </MenuItem>
            )}
            {user.akses.daftarStokBpkb === true && (
              <MenuItem icon={<FormatListNumberedIcon name="profil-icon" />}>
                Daftar Stok BPKB <NavLink to="/daftarStokBpkb" />
              </MenuItem>
            )}
            {user.akses.totalPiutang === true && (
              <MenuItem icon={<RecentActorsIcon name="total-piutang-icon" />}>
                Total Piutang <NavLink to="/totalPiutang" />
              </MenuItem>
            )}
            {user.akses.tunggakan === true && (
              <MenuItem icon={<PlaylistRemoveIcon name="tunggakan-icon" />}>
                Tunggakan <NavLink to="/tunggakan" />
              </MenuItem>
            )}
            {user.akses.spkHarusDibuat === true && (
              <MenuItem
                icon={<PlaylistRemoveIcon name="spk-harus-dibuat-icon" />}
              >
                SPK harus dibuat <NavLink to="/spkHarusDibuat" />
              </MenuItem>
            )}
            {user.akses.lapSuratPemberitahuan === true && (
              <MenuItem
                icon={
                  <PlaylistRemoveIcon name="lap-Surat-Pemberitahuan-icon" />
                }
              >
                Lap. SP <NavLink to="/lapSuratPemberitahuan" />
              </MenuItem>
            )}
            {user.akses.lapSuratPenarikan === true && (
              <MenuItem
                icon={
                  <PlaylistRemoveIcon name="lap-Surat-Pemberitahuan-icon" />
                }
              >
                Lap. ST <NavLink to="/lapSuratPenarikan" />
              </MenuItem>
            )}
            {user.akses.lapSuratSomasi === true && (
              <MenuItem
                icon={
                  <PlaylistRemoveIcon name="lap-Surat-Pemberitahuan-icon" />
                }
              >
                Lap. Surat Somasi <NavLink to="/lapSuratSomasi" />
              </MenuItem>
            )}
            <SubMenu
              title={"Penerimaan Kas"}
              icon={<PublicIcon name="penerimaan-kas-icon" />}
            >
              {user.akses.penerimaanKas === true && (
                <MenuItem>
                  Sama Cabang <NavLink to="/penerimaanKas" />
                </MenuItem>
              )}
              {user.akses.penerimaanKasBedaCabang === true && (
                <MenuItem>
                  Beda Cabang
                  <NavLink to="/penerimaanKasBedaCabang" />
                </MenuItem>
              )}
            </SubMenu>
            {user.akses.kasHarian === true && (
              <MenuItem icon={<TodayIcon name="kas-harian-icon" />}>
                Kas Harian <NavLink to="/kasHarian" />
              </MenuItem>
            )}
            {user.akses.rekapPenerimaan === true && (
              <MenuItem icon={<SoapIcon name="rekap-penerimaan-icon" />}>
                Rekap Penerimaan <NavLink to="/rekapPenerimaan" />
              </MenuItem>
            )}
            {user.akses.penambahanPiutang === true && (
              <MenuItem icon={<SoapIcon name="penambahan-piutang-icon" />}>
                Penambahan Piutang <NavLink to="/penambahanPiutang" />
              </MenuItem>
            )}
            {user.akses.labaRugiPerUnit === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                L/R Per Unit <NavLink to="/labaRugiPerUnit" />
              </MenuItem>
            )}
            {user.akses.lapPenjualan === true && (
              <SubMenu
                title={"Lap. Penjualan"}
                icon={<PointOfSaleIcon name="lap-penjualan-icon" />}
              >
                <MenuItem
                  icon={<AddchartIcon name="penjualan-per-cabang-icon" />}
                >
                  Per Cabang <NavLink to="/penjualanPerCabang" />
                </MenuItem>
                <MenuItem>
                  Per Tipe <NavLink to="/lapPenjualanPerTipe" />
                </MenuItem>
                <MenuItem>
                  Per Marketing <NavLink to="/lapPenjualanPerMarketing" />
                </MenuItem>
                <MenuItem>
                  Per Surveyor <NavLink to="/lapPenjualanPerSurveyor" />
                </MenuItem>
                <MenuItem>
                  Per Supplier <NavLink to="/lapPenjualanPerSupplier" />
                </MenuItem>
                <MenuItem>
                  Kredit&Tunai <NavLink to="/lapPenjualanKreditTunai" />
                </MenuItem>
              </SubMenu>
            )}
            {user.akses.biayaTarikPerSurveyor === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Biaya Tarik/Surveyor <NavLink to="/biayaTarikPerSurveyor" />
              </MenuItem>
            )}
            {user.akses.jemputanPerKolektor === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Jemputan/Kolektor <NavLink to="/jemputanPerKolektor" />
              </MenuItem>
            )}
            {user.akses.konsumenAktifPerSurveyor === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Kon. Aktif/Surveyor <NavLink to="/konsumenAktifPerSurveyor" />
              </MenuItem>
            )}
            {user.akses.point3Bulan === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Point 3 Bulan <NavLink to="/point3Bulan" />
              </MenuItem>
            )}
            {user.akses.lapAngsuran === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Lap. Angsuran <NavLink to="/lapAngsuran" />
              </MenuItem>
            )}
            {user.akses.lapAngsuran === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Lap. Angsuran Historis
                <NavLink to="/lapAngsuranHistoris" />
              </MenuItem>
            )}
            {user.akses.lapGradeAr === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Lap. Grade AR <NavLink to="/lapGradeAr" />
              </MenuItem>
            )}
            {user.akses.lapPenerimaanLebihDari1x === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Lap. Penerimaan {">"} 1x{" "}
                <NavLink to="/lapPenerimaanLebihDari1x" />
              </MenuItem>
            )}
            {user.akses.rekapPencapaianPerSurveyor === true && (
              <MenuItem icon={<SoapIcon name="laba-Rugi-Per-Unit-icon" />}>
                Rekap Pencapaian/Surveyor
                <NavLink to="/rekapPencapaianPerSurveyor" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Accounting"}
            icon={<AccountBalanceWalletIcon name="accounting-icon" />}
          >
            {user.akses.jurnalUmum === true && (
              <MenuItem icon={<PostAddIcon name="jurnalUmum-icon" />}>
                Jurnal Umum <NavLink to="/daftarJurnalUmum" />
              </MenuItem>
            )}
            {user.akses.jurnalUmum === true && (
              <MenuItem icon={<PostAddIcon name="jurnalUmum-icon" />}>
                Lap. Jurnal Umum <NavLink to="/laporanJurnalUmum" />
              </MenuItem>
            )}
            {user.akses.posting === true && (
              <MenuItem icon={<PostAddIcon name="posting-icon" />}>
                Posting <NavLink to="/posting" />
              </MenuItem>
            )}
            {user.akses.unposting === true && (
              <MenuItem icon={<ApprovalIcon name="unposting-icon" />}>
                Unposting <NavLink to="/unposting" />
              </MenuItem>
            )}
            {user.akses.aktivitasBukuBesar === true && (
              <MenuItem
                icon={<RateReviewIcon name="aktivitasBukuBesar-icon" />}
              >
                Aktivitas Buku Besar <NavLink to="/aktivitasBukuBesar" />
              </MenuItem>
            )}
            {user.akses.neracaSaldo === true && (
              <MenuItem icon={<AutoStoriesIcon name="neracaSaldo-icon" />}>
                Neraca Saldo <NavLink to="/neracaSaldo" />
              </MenuItem>
            )}
            {user.akses.labaRugi === true && (
              <MenuItem icon={<MoneyOffIcon name="labaRugi-icon" />}>
                Laba Rugi <NavLink to="/labaRugi" />
              </MenuItem>
            )}
            {user.akses.neraca === true && (
              <MenuItem icon={<BalanceIcon name="neraca-icon" />}>
                Neraca <NavLink to="/neraca" />
              </MenuItem>
            )}
          </SubMenu>
          <SubMenu
            title={"Utility"}
            icon={<ManageAccountsIcon name="utility-icon" />}
          >
            {user.akses.profilUser === true && (
              <MenuItem icon={<PersonSearchIcon name="profil-icon" />}>
                Profil User <NavLink to="/profilUser" />
              </MenuItem>
            )}
            {user.akses.daftarUser === true &&
              user.tipeUser !== "ADM" &&
              user.tipeUser !== "FIN" && (
                <MenuItem icon={<ElevatorIcon name="daftar-icon" />}>
                  Daftar User <NavLink to="/daftarUser" />
                </MenuItem>
              )}
            {user.akses.tutupPeriode === true && user.tipeUser !== "ADM" && (
              <MenuItem icon={<DoorSlidingIcon name="tutupPeriode-icon" />}>
                Tutup Periode <NavLink to="/tutupPeriode" />
              </MenuItem>
            )}
            {user.akses.gantiPeriode === true && user.tipeUser !== "ADM" && (
              <MenuItem icon={<ManageHistoryIcon name="gantiPeriode-icon" />}>
                Ganti Periode <NavLink to="/gantiPeriode" />
              </MenuItem>
            )}
            {user.tipeUser === "OWN/DIREKSI" && user.akses.setting === true && (
              <MenuItem icon={<SettingsIcon name="setting-icon" />}>
                Setting <NavLink to="/setting" />
              </MenuItem>
            )}
          </SubMenu>
        </Menu>
      </SidebarContent>
      {/* FOOTER */}
      <SidebarFooter style={{ textAlign: "center" }}>
        <p style={{ fontSize: "12px", marginTop: "10px" }}>{user.username}</p>
        <p style={{ fontSize: "12px", marginTop: "-10px" }}>
          Cabang : {user.cabang.namaCabang}
        </p>
        <div className="sidebar-btn-wrapper" style={{ paddingBottom: "10px" }}>
          <Link
            className="sidebar-btn"
            style={{ cursor: "pointer" }}
            to="/"
            onClick={logoutButtonHandler}
          >
            <span style={{ marginRight: "6px" }}>Logout</span>
            <FaSignOutAlt />
          </Link>
        </div>
      </SidebarFooter>
    </ProSidebar>
  );
};

export default Sidebar;
